import { Modal } from "antd";
import type { ModalProps } from "antd";
import { CSSProperties } from "react";

export type UIModalProps = Omit<ModalProps, "onCancel"> & {
  onClose?: () => void;
  sx?: Record<string, unknown>;
};

export const UIModal = ({ onClose, children, sx, style, open, ...props }: UIModalProps) => {
  return (
    <Modal
      onCancel={onClose}
      footer={null}
      open={open}
      style={{ ...(sx as CSSProperties), ...(style as CSSProperties) }}
      {...props}
    >
      {children}
    </Modal>
  );
};
